import { c as _c } from "react/compiler-runtime";
import { Button, HStack, VStack, Field } from '@chakra-ui/react';
import { AutoResizeTextarea } from '@src/components/sco/AutoResizeTextarea';
import { HelpModal } from '@src/components/sco/Requests/RequestBuilder/FormSections/HelpModal';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { UpsertGroupRequestInput } from '@src/graphql-types';
import React, { useEffect, useState } from 'react';
export const OpportunitySection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(42);
  const groupRequest = props.groupRequest;
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [needExplanation, setNeedExplanation] = useState(groupRequest.needExplanation || "");
  const [valueToRequester, setValueToRequester] = useState(groupRequest.valueToRequester || "");
  const [valueToResponder, setValueToResponder] = useState(groupRequest.valueToResponder || "");
  let t0;
  let t1;
  if ($[0] !== groupRequest.needExplanation) {
    t0 = () => {
      setNeedExplanation(groupRequest.needExplanation);
    };
    t1 = [groupRequest.needExplanation];
    $[0] = groupRequest.needExplanation;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== needExplanation || $[4] !== props || $[5] !== valueToRequester || $[6] !== valueToResponder) {
    t2 = async t3 => {
      const next = t3 === undefined ? _temp : t3;
      if (!props.groupRequest.groupRequestId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            needExplanation,
            valueToRequester,
            valueToResponder
          } as UpsertGroupRequestInput
        }
      });
      if (next) {
        next();
      }
    };
    $[3] = needExplanation;
    $[4] = props;
    $[5] = valueToRequester;
    $[6] = valueToResponder;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const performSave = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Field.Label>What do you need?</Field.Label>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== performSave) {
    t4 = ev => performSave();
    $[9] = performSave;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => setNeedExplanation(e.target.value);
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== needExplanation || $[13] !== t4) {
    t6 = <Field.Root>{t3}<AutoResizeTextarea maxHeight="200px" placeholder="What are you looking for?" size="sm" value={needExplanation} onBlur={t4} onChange={t5} /></Field.Root>;
    $[12] = needExplanation;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Field.Label>Why does it matter?</Field.Label>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== performSave) {
    t8 = ev_0 => performSave();
    $[16] = performSave;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setValueToRequester(e_0.target.value);
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== valueToRequester) {
    t10 = <Field.Root>{t7}<AutoResizeTextarea maxHeight="200px" size="sm" value={valueToRequester} placeholder="Why is this important to you and your startup? What will you be able to accomplish?" onBlur={t8} onChange={t9} /></Field.Root>;
    $[19] = t8;
    $[20] = valueToRequester;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Field.Label>What's the benefit in helping?</Field.Label>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== performSave) {
    t12 = ev_1 => performSave();
    $[23] = performSave;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_1 => setValueToResponder(e_1.target.value);
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== valueToResponder) {
    t14 = <Field.Root>{t11}<AutoResizeTextarea maxHeight="200px" placeholder="Why should someone respond to your goal? What is in it for them?" size="sm" value={valueToResponder} onBlur={t12} onChange={t13} /></Field.Root>;
    $[26] = t12;
    $[27] = valueToResponder;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== performSave || $[30] !== props) {
    t15 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async e_2 => {
        await performSave(() => props.onNextSection ? props.onNextSection() : null);
      }}>{"Save & Continue"}</Button></HStack>;
    $[29] = performSave;
    $[30] = props;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t14 || $[34] !== t15 || $[35] !== t6) {
    t16 = <VStack align="stretch" gap={4} padding={4}>{t6}{t10}{t14}{t15}</VStack>;
    $[32] = t10;
    $[33] = t14;
    $[34] = t15;
    $[35] = t6;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== showHelpModal) {
    t17 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[37] = showHelpModal;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = <>{t16}{t17}</>;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
function _temp() {}